
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/structure",
      function () {
        return require("private-next-pages/about/structure/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/structure"])
      });
    }
  